import { SimpleTable } from "@components/table/SimpleTable";
import { Column } from "@components/table/table";
import { NFe } from "@models/NFe";
import { useEffect, useState } from "react";
import { ItemModal } from "../modal/ItemModal";
import { TNFeInfNFeDet, TNFeInfNFeDetProdDetExport } from "@models/TNFe";
import { NFCe } from "@models/nfce/NFCe";
import { useNfe } from "@contexts/nfe";

interface NfeTabProps {
    activeNFe: NFe | NFCe
    editMode: boolean
}

const columns: Column[] = [
    { header: 'Numero', accessor: 'number', isActive: true, minWidth: 15 },
    { header: 'Descrição', accessor: 'description', isActive: true, minWidth: 310 },
    { header: 'Quantidade', accessor: 'quantity', isActive: true, minWidth: 130 },
    { header: 'Unidade Comercial', accessor: 'unit', isActive: true, minWidth: 80 },
    { header: 'Valor (R$)', accessor: 'value', isActive: true, minWidth: 80 }
];

export function ItensTab({ activeNFe, editMode }: NfeTabProps) {
    const [dets, setDets] = useState<TNFeInfNFeDet[]>([]);
    const { editedNfe, updateEditedNfe } = useNfe();
    const [selectedItem, setSelectedItem] = useState<TNFeInfNFeDet>();

    function updateDetExports(detExports: TNFeInfNFeDetProdDetExport[], det: TNFeInfNFeDet) {
        const newDets = dets.map((oldDet: TNFeInfNFeDet) => {
            if (oldDet.nitem === det.nitem) {
                return { ...oldDet, prod: { ...oldDet.prod, detExport: detExports } };
            }
            return oldDet;
        });

        setDets(newDets);
        updateEditedNfe({ ...editedNfe, det: newDets });
        setSelectedItem(undefined);
    };

    const onClickRow = (index, _): void => {
        if (editMode) {
            setSelectedItem(dets[index]);
        } else {
            setSelectedItem(activeNFe.infNfe?.det[index]);
        }
    };

    useEffect(() => {
        setDets(editedNfe?.det || activeNFe.infNfe?.det || []);
    }, [editMode, editedNfe, activeNFe]);

    return <>
        <aside className={['bottom-frame', 'edit-border', 'visible'].join(' ')} style={{ marginTop: 10 }}>
            <div className="content">
                <SimpleTable
                    columns={columns}
                    data={dets.map(item => ({
                        id: crypto.randomUUID(),
                        number: item.nitem,
                        description: item.prod.xprod,
                        quantity: item.prod.qcom,
                        unit: item.prod.ucom,
                        value: item.prod.vprod
                    }))}
                    onClickRow={onClickRow}
                />
            </div>
        </aside>
        {selectedItem &&
            <ItemModal
                det={selectedItem}
                handleClose={() => setSelectedItem(undefined)}
                editMode={editMode}
                onUpdateDetExport={updateDetExports}
            />
        }
    </>;
}